import { ICommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { StudentValueModel } from '../../../../../global/components/student_value/model/student_value_model';
import { APUserModeConfig } from '../../../../../global/components/user_mode_config/config/ap_user_mode_config';
import { ICheckboxQuestionMeta, IRadioQuestionMeta } from '../../../intake_survey/builders/ap_intake_survey_builder';
import { IInTakeSurveyQuestionChoice } from '../../../intake_survey/builders/ap_intake_survey_question_choice_builder';
import { APIntakeSurveyNKHelper } from '../../helpers/intake_survey_nk_helper';
import { APAdvisorText } from './../../../../../global/servants/ap_advisor_text_servant';

class PreviewTermsPlan {
  private questions: any[];
  private terms: any[];
  private disableEditing: boolean;
  private alertTemplateIssue: boolean = false;
  private alertSelectMoreTerms: boolean = false;
  private contactAdvisorButton: boolean = false;
  private preferenceSavingDisabled: boolean = false;
  private isAdvisor: boolean = false;
  private timeCommitmentQuestion: IRadioQuestionMeta;
  private termPreferenceQuestion: ICheckboxQuestionMeta;
  private previouslySelectedChoices:
    | [IInTakeSurveyQuestionChoice['nk'], Array<IInTakeSurveyQuestionChoice['nk']>]
    | any = [];
  private previousUrl: string;
  private saveAndPlanButtonLabel: string;
  private contactAdvisorButtonLabel: string;
  private updateStudentAutoGeneratedFlag: boolean = false;
  private goBackState: string;
  constructor(
    private $timeout: ng.ITimeoutService,
    private appConfigModel: any,
    private FEATURE_APPOINTMENTS: any,
    private loadTermPreviewPlanCommand: ICommand,
    private ngTermPlanPreviewQuery: IQuery,
    private $state: ng.ui.IStateService,
    private saveMultipleQuestionAnswerCommand: ICommand,
    private createEmptyTermsCommand: ICommand,
    private ngAPUserModeConfig: APUserModeConfig,
    private ngStudentValueModel: StudentValueModel,
    private completedAutoGeneratedPreviewPlanShowingCommand: ICommand,
    private ngPreviewTermPlanConstant: any,
    private ngAPAdvisorText: APAdvisorText,
    private phxFeatureConfiguration: any,
    private ngAPIntakeSurveyNKHelper: APIntakeSurveyNKHelper
  ) {
    this.contactAdvisorButton = this.appConfigModel.isFeatureEnabled(FEATURE_APPOINTMENTS);
    const advisorLabel = this.ngAPAdvisorText.advisorLabel;
    this.contactAdvisorButtonLabel = `Contact ${advisorLabel}`;
    this.terms = [];
    this.previousUrl = $state.params.source || '';
    this.saveAndPlanButtonLabel = $state.params.source === 'autoGenerated' ? 'Plan From Scratch' : 'Save Preferences';
    this.isAdvisor = this.$state.includes('ap-advisor');
    this.preferenceSavingDisabled = this.isAdvisor;
    this.updateStudentAutoGeneratedFlag = this.isAdvisor;
    this.goBackState = this.isAdvisor ? 'ap-advisor.plan' : 'my.planner.default';
  }

  $onInit() {
    this.initialize();
  }

  $onChanges() {
    this.initialize();
  }

  getSelectedChoices() {
    return [this.timeCommitmentQuestion._answer.nk, _4.map(this.termPreferenceQuestion._answer, 'nk')];
  }

  shouldDisablePreviewPlanButton() {
    return _4.isEqual(this.previouslySelectedChoices, this.getSelectedChoices());
  }

  initialize() {
    this.timeCommitmentQuestion = _4.find(this.questions, {
      nk: this.ngAPIntakeSurveyNKHelper.intakeSurveyTimeCommitmentNK
    });
    this.termPreferenceQuestion = _4.find(this.questions, {
      nk: this.ngAPIntakeSurveyNKHelper.intakeSurveyTermPreferenceNK
    });
  }

  removeAlert(alert: string) {
    if (alert === 'templateIssue') {
      this.alertTemplateIssue = false;
    } else {
      this.alertSelectMoreTerms = false;
    }
  }

  reportProblemClicked() {
    const contactFormTrigger = angular.element('app-support button');
    this.$timeout(() => contactFormTrigger.triggerHandler('click'), 0);
  }

  async savePreferenceClicked() {
    const [termCommitment, termPreference] = this.getSelectedChoices();
    const savePreference = this.saveMultipleQuestionAnswerCommand([
      this.timeCommitmentQuestion,
      this.termPreferenceQuestion
    ]);
    const createEmptyTerms = this.createEmptyTermsCommand(termCommitment, termPreference);
    await savePreference;
    await createEmptyTerms;
    this.$state.go(this.goBackState);
  }

  exitClicked() {
    if (!this.isAdvisor) {
      this.$state.go(this.goBackState);
      return;
    }
    this.afterSaving();
  }

  async afterSaving() {
    if (!this.preferenceSavingDisabled) {
      await this.saveMultipleQuestionAnswerCommand([this.timeCommitmentQuestion, this.termPreferenceQuestion]);
    }
    if (this.updateStudentAutoGeneratedFlag) {
      await this.completedAutoGeneratedPreviewPlanShowingCommand();
      const currentStudentValue = {};
      this.ngStudentValueModel
        .keys()
        .forEach((key: string) => (currentStudentValue[key] = this.ngStudentValueModel.getValueByKey(key)));
      currentStudentValue[this.ngPreviewTermPlanConstant['AP_PREVIEW_AUTO_GENERATED_TERM_PLAN_SHOWN']] = 'True';
      this.ngStudentValueModel.update(currentStudentValue);
    }
    this.$state.go(this.goBackState);
  }
}

angular.module('capability-ng-academic-planner').component('previewTermsPlan', {
  templateUrl:
    'capability-ng-academic-planner/src/preferences/components/preview_plan/components/preview_terms_plan/preview_terms_plan.html',
  bindings: {
    questions: '<'
  },
  controller: PreviewTermsPlan
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/preferences/components/preview_plan/components/preview_terms_plan/preview_terms_plan.ts